import { services2 } from '/api/services2';

export const segmentationService = services2.appSegmentsService;
export const segmentationServiceName = segmentationService.getClassName();

// the same names as the names of the methods in /common/scripts/definitions/script-hooks.d.ts
export const SEGMENTATION_SAVE_HOOK_NAME = 'onSegmentationSave';
export const SEGMENTATION_PROMOTE_HOOK_NAME = 'onSegmentationPromote';
export const SEGMENTATION_DEMOTE_HOOK_NAME = 'onSegmentationDemote';
